import axios from "axios";

const createApiClient = (baseURL, includeToken = true) => {
  const api = axios.create({
    baseURL: baseURL || "http://localhost:8080//server",
    // baseURL: baseURL || "https://gorumble.best121.com/server",
  });

  api.interceptors.request.use((config) => {
    if (includeToken) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  return api;
};

export default createApiClient;
